import client from "./client";
import { fetchCachedPublicGet } from "./publicRequest";

const buildQuery = (params = {}) => {
  const search = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  );
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const fetchSafariFeed = (params = {}, options = {}) =>
  fetchCachedPublicGet(`/explore/experiences/feed${buildQuery(params)}`, options);

export const fetchSafariDetail = (destinationSlug, safariSlug, options = {}) => {
  if (!destinationSlug || !safariSlug) {
    return Promise.reject(new Error("Destination or safari slug missing"));
  }
  const requestOptions = { ...options };
  const path = `/explore/experiences/${destinationSlug}/${safariSlug}${buildQuery({ view: options.view })}`;
  delete requestOptions.view;
  return fetchCachedPublicGet(path, requestOptions);
};

export const fetchPortalSafariList = (params = {}) => client.get(`/portal/experiences${buildQuery(params)}`);

export const fetchPortalSafariDetail = (identifier, params = {}) => {
  if (!identifier) {
    return Promise.reject(new Error("Safari identifier is required"));
  }
  return client.get(`/portal/experiences/${identifier}${buildQuery(params)}`);
};

export const fetchSafariAvailability = (identifier) => {
  if (!identifier) return Promise.reject(new Error("Safari identifier is required"));
  return client.get(`/portal/experience-bookings/${identifier}/availability`);
};

export const createSafariQuote = (identifier, payload) => {
  if (!identifier) return Promise.reject(new Error("Safari identifier is required"));
  return client.post(`/portal/experience-bookings/${identifier}/quote`, payload);
};

export const createSafariBooking = (identifier, payload) => {
  if (!identifier) return Promise.reject(new Error("Safari identifier is required"));
  return client.post(`/portal/experience-bookings/${identifier}/bookings`, payload);
};

export const fetchSafariBooking = (referenceCode) => {
  if (!referenceCode) return Promise.reject(new Error("Booking reference is required"));
  return client.get(`/portal/experience-bookings/bookings/${referenceCode}`);
};
